export default {"src":"/parent/_next/static/media/nest-logo-with-name.019592aa.svg","height":139,"width":420,"blurWidth":0,"blurHeight":0};